import SubScriptionManagerBase from "./subscriptionmanagerbase";
import { generateError, createError } from "./../../common/utilities/utils";

import { AUTHENTICATED } from "./../../common/analytics/analyticsevents";

// this class will implement al the necessary API communication
// and cookie management to authenticate users and authorize
// downloads. It does not implement any UI elements.
export default class SubScriptionManagerSSO extends SubScriptionManagerBase {
  // Returns the current authentication state.
  get isAuthenticated() {
    return this._authenticated;
  }

  get ssoState() {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    return JSON.parse(stateCookieValue).state;
  }
  // irrelevant for the SSO subscriptionmanager, will reject always
  // eslint-disable-next-line
  authenticateByUserNamePassword(username, password) {
    return Promise.reject("not allowed in sso");
  }

  // returns a promise that will either reject with an error code when authentication
  // fails, either resolves to success. This is to be used in case of SSO, or
  // to check if you are autenticated
  // in any case it will also trigger the authenticationstatuschanged event if
  // the current status changed.
  authenticate(downloadToken) {
    this.downloadToken = downloadToken;
    const authenticationPromise = new Promise((resolve, reject) => {
      let ssoToken = false;
      let ssoState = false;
      if (this._options.getSSOTokenFromUrl) {
        ssoToken = this._getQueryVariable(this._options.urlSSOTokenParameter);
        if (this._options.generateSSOState) {
          ssoState = this._getQueryVariable("state");
        }
      }
      if (!ssoToken) {
        // check if there is an SSO cookie if the settings are SSO enabled,
        let cookie;
        const rawCookie = this._cookieManager.getCookie(
          this._options.SSOCookieName
        );
        if (rawCookie) {
          try {
            cookie = JSON.parse(rawCookie);
          } catch (e) {
            this._removeSSOCookie();
            ssoToken = rawCookie;
          }
        }

        if (cookie && cookie.token) {
          //always remove cookie
          this._removeSSOCookie();
          ssoToken = cookie.token;
          if (typeof ssoToken == "number") {
            ssoToken = ssoToken.toString();
          }
          if (cookie.hash) {
            ssoToken = `${cookie.hash}|${ssoToken}`;
          }
        }
      }
      if (ssoToken) {
        let stateExist = typeof ssoState == "string" ? true : false;
        let isValidState = false;

        if (stateExist && this._isStateValid()) {
          if (ssoState === this.ssoState && ssoToken) {
            isValidState = true;
          }
        }

        if (!stateExist || isValidState) {
          this._sessionManager
            .getSessionInfo()
            .then((sessionId) => {
              const userId = this._sessionManager.userId;
              const subsType =
                this._options.subscriptionOptions.subscriptionProvider;
              this._apiManager
                .validateSubscriptionToken(
                  userId,
                  sessionId,
                  ssoToken,
                  downloadToken,
                  subsType
                )
                .then((data) => {
                  if (data.Status.toLowerCase() === "success") {
                    this._authenticatedSucces(data);
                    this._appState.triggerEvent(AUTHENTICATED);
                    resolve(data);
                  } else {
                    this._removeSSOCookie(true);
                    data.call = "validateSubscriptionToken";
                    data.errorType = "authentication";
                    reject(generateError(data));
                  }
                })
                .catch((error) => {
                  // not valid SSO
                  //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
                  this._removeSSOCookie(true);
                  reject(
                    createError(
                      "VST-ERR",
                      "ValidateSubscriptionToken failed",
                      error
                    )
                  );
                }); // eslint-disable-next-line
            })
            .catch(() => {
              //no valid session
              //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
              this._removeSSOCookie(true);
              reject("no valid session"); //TODO: right error code
            });
        }
      } else {
        //remove the sso cookie, since we where not able to aunthenticate with the sso cookie there is no need of keeping it
        this._removeSSOCookie(true);
        reject("no sso cookie"); //TODO: right error code
      }
    });
    return authenticationPromise;
  }

  _getQueryVariable(variable) {
    const urlQuery = window.location.search.substring(1);
    const parameters = urlQuery.split("&");
    for (let i = 0; i < parameters.length; i++) {
      let pair = parameters[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  _removeSSOCookie(force = false) {
    if (force || this._options.deleteSSOCookie) {
      this._cookieManager.removeCookie(
        this._options.SSOCookieName,
        this._options.SSOCookieOptions
      );
      this.removeSSOStateCookie(true);
    }
  }

  _authenticatedSucces(data) {
    this._authenticated = true;
    // store subscriptionCookie
    this._createSubscriptionCookie(
      data.SubscriptionID,
      data.SubscriptionReference,
      data.SubscriptionUserReference,
      data.SubscriptionType
    );
    this.trigger("subscriptionmanager:authenticationstatuschanged");
    this.redirect();
  }

  // returns a promise that will either reject with an error code when authorization
  // fails, either resolves to success. It will also execute the authentication
  // if not yet authenticated. It will also potentially triger the
  // authenticationstatuschanged event
  authorize(
    publicationData = {
      contentPackageId: -1,
      publicationId: -1,
      price: -1,
    }
  ) {
    const authorizationPromise = new Promise((resolve, reject) => {
      if (publicationData.price !== 0) {
        this.isFreePublication = false;
        this.authenticate()
          .then(() => {
            // call Authorization methods and return the promises
            resolve();
          })
          .catch((error) => {
            // something went wrong reject it.
            reject(error);
          });
      } else {
        // 0 priced publications are always authorized
        this.isFreePublication = true;
        resolve();
      }
    });
    return authorizationPromise;
  }
  //LUX Case

  setSSOState(redirectUrl) {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    var date = new Date();
    var minutes = 10;
    date.setTime(date.getTime() + minutes * 60 * 1000);
    if (!stateCookieValue) {
      const ssoState =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15) +
        "-" +
        Date.now();
      this._cookieManager.createCookie(
        this._cookieManager.cookieKeys.SSO_STATE,
        JSON.stringify({
          state: ssoState,
          redirectUrl: redirectUrl,
        }),
        {
          expires: date,
          path: "/",
          useTime: true,
        }
      );
    } else {
      /* To avoid always being redirected to the home even when we click on a publication we always update the url stored in the state cookie */
      if (redirectUrl && redirectUrl != "") {
        const cookieSSOState = JSON.parse(stateCookieValue).state;
        this.removeSSOStateCookie(true);
        this._cookieManager.createCookie(
          this._cookieManager.cookieKeys.SSO_STATE,
          JSON.stringify({
            state: cookieSSOState,
            redirectUrl: redirectUrl,
          }),
          {
            expires: date,
            path: "/",
            useTime: true,
          }
        );
      }
    }
  }

  removeSSOStateCookie(force = true) {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    if (stateCookieValue && force) {
      this._cookieManager.removeCookie(
        this._cookieManager.cookieKeys.SSO_STATE,
        {
          expires: -1,
          path: "/",
        }
      );
    }
  }

  _isStateValid() {
    const stateTimestamp = this.ssoState.split("-")[1];
    const stateTimeStampInSeconds = parseInt(Math.floor(stateTimestamp / 1000));
    const stateTimeStampInMinutes = parseInt(
      Math.floor(stateTimeStampInSeconds / 60)
    );

    const now = parseInt(Math.floor(Date.now() / 1000));
    const nowInMinutes = parseInt(Math.floor(now / 60));

    if (nowInMinutes - stateTimeStampInMinutes > 10) {
      return false;
    } else {
      return true;
    }
  }

  redirect() {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    if (stateCookieValue) {
      const redirectUrl = JSON.parse(stateCookieValue).redirectUrl;
      if (redirectUrl && redirectUrl != null) {
        this.removeSSOStateCookie(true);
        window.location.href = decodeURIComponent(redirectUrl);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/subscriptionmanagersso.js